export default {
  data() {
    return {
      valid: {
        category: false,
        image: true,
        tag: false,
        rewardPoints: false,
        rewardType: false,
        name: false,
        description: false,
        sellingPrice: false,
        wholesalePrice: false,
        maxPrice: false,
        productIdentifier: false,
      },
      success: {
        category: false,
        image: false,
        tag: false,
        rewardPoints: false,
        rewardType: false,
        name: false,
        description: false,
        sellingPrice: false,
        wholesalePrice: false,
        maxPrice: false,
        productIdentifier: false,
      },
      error: {
        category: '',
        image: '',
        tag: '',
        rewardPoints: '',
        rewardType: '',
        name: '',
        description: '',
        sellingPrice: '',
        wholesalePrice: '',
        maxPrice: '',
        productIdentifier: '',
      },
      errorMessages: {
        categoryRequired: {
          el: 'Η κατηγορία είναι υποχρεωτική',
          en: 'Category is required',
          it: 'La categoria è obbligatoria',
        },
        tagRequired: {
          el: 'Η ετικέτα προϊόντος είναι υποχρεωτική',
          en: 'Product Tag is required',
          it: 'Il tag del prodotto è obbligatorio',
        },
        nameRequired: {
          el: 'Το όνομα είναι υποχρεωτικό',
          en: 'Name is required',
          it: 'Il nome è obbligatorio',
        },
        descriptionRequired: {
          el: 'Η περιγραφή είναι υποχρεωτική',
          en: 'Description is required',
          it: 'La descrizione è obbligatoria',
        },
        sellingPriceRequired: {
          el: 'Η τιμή πώλησης είναι υποχρεωτική',
          en: 'Selling Price is required',
          it: 'Il prezzo di vendita è obbligatorio',
        },
        sellingPriceMin: {
          el: 'Η τιμή πώλησης πρέπει να είναι τουλάχιστον 0,1',
          en: 'Selling Price must be minimum 0.1',
          it: 'Il prezzo di vendita deve essere almeno 0,1',
        },
        wholesalePriceMin: {
          el: 'Η χονδρική τιμή πρέπει να είναι τουλάχιστον 0,1',
          en: 'Wholesale Price must be minimum 0.1',
          it: "Il prezzo all'ingrosso deve essere almeno 0,1",
        },
        maxPriceMin: {
          el: 'Μέγιστη τιμή ανά συναλλαγή Η τιμή πρέπει να είναι τουλάχιστον 0,1',
          en: 'Maximum price per transaction Price must be minimum 0.1',
          it: 'Prezzo massimo per transazione Il prezzo deve essere minimo 0,1',
        },
        imageTooLarge: {
          el: 'Η εικόνα υπερβαίνει το όριο %dKB',
          en: 'Image exceeds %dKB limit',
          it: "L'immagine supera il limite di %dKB",
        },
        imageInvalidType: {
          el: 'Η εικόνα πρέπει να είναι PNG/JPG/JPEG',
          en: 'Image must be png/jpg/jpeg',
          it: "L'immagine deve essere png/jpg/jpeg",
        },
        imageRequired: {
          el: 'Παρακαλώ, επιλέξτε μια εικόνα',
          en: 'Please, select an image',
          it: "Per favore, seleziona un'immagine",
        },
        rewardPointsRequired: {
          el: 'Απαιτούνται πόντοι ανταμοιβής',
          en: 'Reward points is required',
          it: 'I punti premio sono obbligatori',
        },
        rewardTypeRequired: {
          el: 'Απαιτείται τύπος ανταμοιβής',
          en: 'Reward type is required',
          it: 'Il tipo di premio è obbligatorio',
        },
        productIdentifierInvalid: {
          el: 'Μη έγκυρος αναγνωριστικός αριθμός προϊόντος',
          en: 'Invalid product identifier',
          it: 'Identificatore prodotto non valido',
        },
      },
    };
  },

  computed: {
    formValid() {
      return (
        this.valid.image &&
        this.valid.name &&
        this.valid.description &&
        this.valid.sellingPrice &&
        this.valid.rewardPoints &&
        this.valid.rewardType
      );
    },
  },

  methods: {
    validateImage(file) {
      const requiresImage = Boolean(this.product && this.product.has_image);

      if (!file) {
        if (requiresImage) {
          if (this.product && this.product.image) {
            this.error.image = '';
            this.valid.image = true;
            this.success.image = true;
            return true;
          }

          this.error.image =
            (this.errorMessages.imageRequired && this.errorMessages.imageRequired[this.lang]) ||
            'Image is required';
          this.valid.image = false;
          this.success.image = false;
          return false;
        }

        this.error.image = '';
        this.valid.image = true;
        this.success.image = false;
        return true;
      }

      const maxKB = 5000;
      const maxBytes = maxKB * 1024;
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];

      if (file.size > maxBytes) {
        const msgTemplate =
          this.errorMessages.imageTooLarge[this.lang] || `Image exceeds ${maxKB}KB limit`;
        this.error.image = msgTemplate.replace('%d', maxKB);
        this.valid.image = false;
        this.success.image = false;
        return false;
      }

      if (!allowedTypes.includes(file.type)) {
        this.error.image = this.errorMessages.imageInvalidType[this.lang];
        this.valid.image = false;
        this.success.image = false;
        return false;
      }

      this.error.image = '';
      this.valid.image = true;
      this.success.image = true;
      return true;
    },

    validateTag() {
      if (!this.product.product_tag_id) {
        this.error.tag = this.errorMessages.tagRequired[this.lang];
      } else {
        this.error.tag = '';
      }
    },

    validateName() {
      const missing = [];
      if (!this.product.name || !this.product.name.el) missing.push('el');
      if (!this.product.name || !this.product.name.en) missing.push('en');
      if (!this.product.name || !this.product.name.it) missing.push('it');

      if (missing.length > 0) {
        this.error.name = this.errorMessages.nameRequired[this.lang];
        this.valid.name = false;
        this.success.name = false;
      } else {
        this.error.name = '';
        this.valid.name = true;
        this.success.name = true;
      }
    },

    validateDescription() {
      const missing = [];
      if (!this.product.description || !this.product.description.el) missing.push('el');
      if (!this.product.description || !this.product.description.en) missing.push('en');
      if (!this.product.description || !this.product.description.it) missing.push('it');

      if (missing.length > 0) {
        this.error.description = this.errorMessages.descriptionRequired[this.lang];
        this.valid.description = false;
        this.success.description = false;
      } else {
        this.error.description = '';
        this.valid.description = true;
        this.success.description = true;
      }
    },

    validateSellingPrice() {
      const isGroup = Boolean(this.product.group_product);

      if (isGroup) {
        this.error.sellingPrice = '';
        this.valid.sellingPrice = true;
        this.success.sellingPrice = false;
        return;
      }

      const val = this.product.retail_price;
      if (val === null || val === undefined || val === '') {
        this.error.sellingPrice = this.errorMessages.sellingPriceRequired[this.lang];
        this.valid.sellingPrice = false;
        this.success.sellingPrice = false;
      } else if (isNaN(Number(val))) {
        this.error.sellingPrice = this.errorMessages.sellingPriceRequired[this.lang];
        this.valid.sellingPrice = false;
        this.success.sellingPrice = false;
      } else if (Number(val) < 0.1) {
        this.error.sellingPrice = this.errorMessages.sellingPriceMin[this.lang];
        this.valid.sellingPrice = false;
        this.success.sellingPrice = false;
      } else {
        this.error.sellingPrice = '';
        this.valid.sellingPrice = true;
        this.success.sellingPrice = true;
      }
    },

    validateRewardPoints() {
      const val = this.product.reward_points;
      if (val === null || val === undefined || val === '') {
        this.error.rewardPoints = this.errorMessages.rewardPointsRequired[this.lang];
        this.valid.rewardPoints = false;
        this.success.rewardPoints = false;
      } else {
        this.error.rewardPoints = '';
        this.valid.rewardPoints = true;
        this.success.rewardPoints = true;
      }
    },

    validateRewardType() {
      if (!this.product.reward_type_id) {
        this.error.rewardType = this.errorMessages.rewardTypeRequired[this.lang];
        this.valid.rewardType = false;
        this.success.rewardType = false;
      } else {
        this.error.rewardType = '';
        this.valid.rewardType = true;
        this.success.rewardType = true;
      }
    },

    validateWholesalePrice() {
      if (!this.product.wholesale_price) {
        this.error.wholesalePrice = '';
      } else if (this.product.wholesale_price < 0.1) {
        this.error.wholesalePrice = this.errorMessages.wholesalePriceMin[this.lang];
      } else {
        this.error.wholesalePrice = '';
      }
    },

    validateMaxPrice() {
      if (Number(this.product.maximum_price_per_transaction) == 0) {
        this.error.maxPrice = '';
      } else if (this.product.maximum_price_per_transaction < 0.1) {
        this.error.maxPrice = this.errorMessages.maxPriceMin[this.lang];
      } else {
        this.error.maxPrice = '';
      }
    },

    handleServerValidationErrors(serverErrors) {
      if (!serverErrors) return;

      if (typeof this.setResetValidation === 'function') {
        this.setResetValidation(true);
      }

      const flattenKeys = (obj, prefix = '') => {
        let out = [];
        if (!obj || typeof obj !== 'object') return out;
        Object.keys(obj).forEach((k) => {
          const val = obj[k];
          const key = prefix ? `${prefix}.${k}` : k;
          if (val && typeof val === 'object' && !Array.isArray(val)) {
            out = out.concat(flattenKeys(val, key));
          } else {
            out.push(key);
          }
        });
        return out;
      };

      const getMessageForKey = (key, obj) => {
        if (!obj) return null;
        if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
        const parts = key.split('.');
        let cur = obj;
        for (let p of parts) {
          if (cur && Object.prototype.hasOwnProperty.call(cur, p)) {
            cur = cur[p];
          } else {
            cur = null;
            break;
          }
        }
        if (!cur) return null;
        if (Array.isArray(cur)) return cur.join(' ');
        if (typeof cur === 'string') return cur;
        const collect = (o) => {
          if (!o) return [];
          if (Array.isArray(o)) return o;
          if (typeof o === 'string') return [o];
          let res = [];
          Object.keys(o).forEach((k) => {
            res = res.concat(collect(o[k]));
          });
          return res;
        };
        const msgs = collect(cur);
        return msgs.length ? msgs.join(' ') : null;
      };

      this.$nextTick(() => {
        const processMessageText = (msgText) => {
          if (!msgText) return;
          const parts = msgText
            .split('.')
            .map((p) => p.trim())
            .filter(Boolean);

          parts.forEach((p) => {
            const s = p.toLowerCase();

            if (s.includes('name')) {
              this.validateName();
              if (!this.error.name) this.error.name = this.errorMessages.nameRequired[this.lang];
              this.valid.name = this.error.name ? false : this.valid.name;
              this.success.name = this.error.name ? false : this.success.name;
            }

            if (s.includes('description')) {
              this.validateDescription();
              if (!this.error.description)
                this.error.description = this.errorMessages.descriptionRequired[this.lang];
              this.valid.description = this.error.description ? false : this.valid.description;
              this.success.description = this.error.description ? false : this.success.description;
            }

            if (
              s.includes('retail') ||
              s.includes('selling') ||
              s.includes('retail price') ||
              s.includes('retail_price')
            ) {
              this.validateSellingPrice();
              if (!this.error.sellingPrice)
                this.error.sellingPrice = this.errorMessages.sellingPriceRequired[this.lang];
              this.valid.sellingPrice = this.error.sellingPrice ? false : this.valid.sellingPrice;
              this.success.sellingPrice = this.error.sellingPrice
                ? false
                : this.success.sellingPrice;
            }

            if (s.includes('wholesale')) {
              this.validateWholesalePrice();
              if (!this.error.wholesalePrice)
                this.error.wholesalePrice = this.errorMessages.wholesalePriceMin[this.lang];
              this.valid.wholesalePrice = this.error.wholesalePrice
                ? false
                : this.valid.wholesalePrice;
              this.success.wholesalePrice = this.error.wholesalePrice
                ? false
                : this.success.wholesalePrice;
            }

            if (s.includes('maximum') || s.includes('max')) {
              this.validateMaxPrice();
              if (!this.error.maxPrice)
                this.error.maxPrice = this.errorMessages.maxPriceMin[this.lang];
              this.valid.maxPrice = this.error.maxPrice ? false : this.valid.maxPrice;
              this.success.maxPrice = this.error.maxPrice ? false : this.success.maxPrice;
            }

            if (s.includes('reward points') || s.includes('reward_points')) {
              this.validateRewardPoints();
              if (!this.error.rewardPoints)
                this.error.rewardPoints = this.errorMessages.rewardPointsRequired[this.lang];
              this.valid.rewardPoints = this.error.rewardPoints ? false : this.valid.rewardPoints;
              this.success.rewardPoints = this.error.rewardPoints
                ? false
                : this.success.rewardPoints;
            }

            if (s.includes('reward type') || s.includes('reward_type')) {
              this.validateRewardType();
              if (!this.error.rewardType)
                this.error.rewardType = this.errorMessages.rewardTypeRequired[this.lang];
              this.valid.rewardType = this.error.rewardType ? false : this.valid.rewardType;
              this.success.rewardType = this.error.rewardType ? false : this.success.rewardType;
            }

            if (s.includes('product tag') || s.includes('product_tag')) {
              this.validateTag();
              if (!this.error.tag) this.error.tag = this.errorMessages.tagRequired[this.lang];
              this.valid.tag = this.error.tag ? false : this.valid.tag;
              this.success.tag = this.error.tag ? false : this.success.tag;
            }

            if (s.includes('category')) {
              this.error.category = this.errorMessages.categoryRequired[this.lang];
              this.valid.category = false;
              this.success.category = false;
            }

            if (s.includes('image')) {
              this.validateImage(this.imageFile);
              if (!this.error.image) this.error.image = this.errorMessages.imageRequired[this.lang];
              this.valid.image = this.error.image ? false : this.valid.image;
              this.success.image = this.error.image ? false : this.success.image;
            }

            if (
              s.includes('sku') ||
              s.includes('sku number') ||
              s.includes('product identifier') ||
              s.includes('product_identifier')
            ) {
              this.error.productIdentifier = this.errorMessages.productIdentifierInvalid[this.lang];
              this.valid.productIdentifier = false;
              this.success.productIdentifier = false;
            }
          });
        };

        let messageString = null;
        if (typeof serverErrors === 'string') {
          messageString = serverErrors;
        } else if (serverErrors && serverErrors.message) {
          messageString = getMessageForKey('message', serverErrors) || serverErrors.message;
        }

        if (messageString) {
          processMessageText(messageString);
          this.setErrorMessage(messageString, { root: true });
          setTimeout(() => this.setErrorMessage('', { root: true }), 5000);
        }

        const keys = flattenKeys(serverErrors);
        const distinct = [...new Set(keys)];

        distinct.forEach((key) => {
          if (key === 'message') return;
          const kl = key.toLowerCase();
          const msg = getMessageForKey(key, serverErrors);

          if (kl.includes('name')) {
            this.validateName();
            if (!this.error.name) this.error.name = this.errorMessages.nameRequired[this.lang];
            this.valid.name = this.error.name ? false : this.valid.name;
            this.success.name = this.error.name ? false : this.success.name;
          }

          if (kl.includes('description')) {
            this.validateDescription();
            if (!this.error.description)
              this.error.description = this.errorMessages.descriptionRequired[this.lang];
            this.valid.description = this.error.description ? false : this.valid.description;
            this.success.description = this.error.description ? false : this.success.description;
          }

          if (kl.includes('retail') || kl.includes('selling')) {
            this.validateSellingPrice();
            if (!this.error.sellingPrice)
              this.error.sellingPrice = this.errorMessages.sellingPriceRequired[this.lang];
            this.valid.sellingPrice = this.error.sellingPrice ? false : this.valid.sellingPrice;
            this.success.sellingPrice = this.error.sellingPrice ? false : this.success.sellingPrice;
          }

          if (kl.includes('wholesale')) {
            this.validateWholesalePrice();
            if (!this.error.wholesalePrice)
              this.error.wholesalePrice = this.errorMessages.wholesalePriceMin[this.lang];
            this.valid.wholesalePrice = this.error.wholesalePrice
              ? false
              : this.valid.wholesalePrice;
            this.success.wholesalePrice = this.error.wholesalePrice
              ? false
              : this.success.wholesalePrice;
          }

          if (kl.includes('maximum') || kl.includes('max')) {
            this.validateMaxPrice();
            if (!this.error.maxPrice)
              this.error.maxPrice = this.errorMessages.maxPriceMin[this.lang];
            this.valid.maxPrice = this.error.maxPrice ? false : this.valid.maxPrice;
            this.success.maxPrice = this.error.maxPrice ? false : this.success.maxPrice;
          }

          if (kl.includes('reward_points')) {
            this.validateRewardPoints();
            if (!this.error.rewardPoints)
              this.error.rewardPoints = this.errorMessages.rewardPointsRequired[this.lang];
            this.valid.rewardPoints = this.error.rewardPoints ? false : this.valid.rewardPoints;
            this.success.rewardPoints = this.error.rewardPoints ? false : this.success.rewardPoints;
          }

          if (kl.includes('reward_type')) {
            this.validateRewardType();
            if (!this.error.rewardType)
              this.error.rewardType = this.errorMessages.rewardTypeRequired[this.lang];
            this.valid.rewardType = this.error.rewardType ? false : this.valid.rewardType;
            this.success.rewardType = this.error.rewardType ? false : this.success.rewardType;
          }

          if (kl.includes('product_tag')) {
            this.validateTag();
            if (!this.error.tag) this.error.tag = this.errorMessages.tagRequired[this.lang];
            this.valid.tag = this.error.tag ? false : this.valid.tag;
            this.success.tag = this.error.tag ? false : this.success.tag;
          }

          if (kl.includes('product_category')) {
            this.error.category = this.errorMessages.categoryRequired[this.lang];
            this.valid.category = false;
            this.success.category = false;
          }

          if (kl.includes('image')) {
            this.validateImage(this.imageFile);
            if (!this.error.image) this.error.image = this.errorMessages.imageRequired[this.lang];
            this.valid.image = this.error.image ? false : this.valid.image;
            this.success.image = this.error.image ? false : this.success.image;
          }

          if (kl.includes('sku') || kl.includes('product_identifier')) {
            this.error.productIdentifier = this.errorMessages.productIdentifierInvalid[this.lang];
            this.valid.productIdentifier = false;
            this.success.productIdentifier = false;
          }
        });

        if (this.$store && this.$store.commit) {
          this.setValidationErrors({});
        }
      });
    },
  },

  watch: {
    ['product.product_category_id']: {
      immediate: true,
      handler(val) {
        this.valid.category = Boolean(val);
        this.success.category = Boolean(val);
      },
    },

    ['product.name.en']: {
      immediate: true,
      handler() {
        this.valid.name = Boolean(
          this.product.name && this.product.name.el && this.product.name.en && this.product.name.it
        );
        this.success.name = this.valid.name;
      },
    },

    ['product.name.it']: {
      immediate: true,
      handler() {
        this.valid.name = Boolean(
          this.product.name && this.product.name.el && this.product.name.en && this.product.name.it
        );
        this.success.name = this.valid.name;
      },
    },

    productLang(val) {
      if (val === 'en' || val === 'it') {
        this.error.name = '';
      }
    },

    descriptionLang(val) {
      if (val === 'en' || val === 'it') {
        this.error.description = '';
      }
    },

    ['product.name.el']: {
      immediate: true,
      handler(val) {
        this.valid.name = Boolean(val);
        this.success.name = Boolean(val);
      },
    },

    ['product.description.el']: {
      immediate: true,
      handler(val) {
        this.valid.description = Boolean(
          this.product.description &&
            this.product.description.el &&
            this.product.description.en &&
            this.product.description.it
        );
        this.success.description = this.valid.description;
      },
    },

    ['product.description.en']: {
      immediate: true,
      handler() {
        this.valid.description = Boolean(
          this.product.description &&
            this.product.description.el &&
            this.product.description.en &&
            this.product.description.it
        );
        this.success.description = this.valid.description;
      },
    },

    ['product.description.it']: {
      immediate: true,
      handler() {
        this.valid.description = Boolean(
          this.product.description &&
            this.product.description.el &&
            this.product.description.en &&
            this.product.description.it
        );
        this.success.description = this.valid.description;
      },
    },

    ['product.retail_price']: {
      immediate: true,
      handler(val) {
        this.validateSellingPrice();
      },
    },

    ['product.maximum_price_per_transaction']: {
      immediate: true,
      handler(val) {
        this.valid.maxPrice = val >= 0.1 || !Number(val);
        this.success.maxPrice = val >= 0.1;
      },
    },

    ['product.wholesale_price']: {
      immediate: true,
      handler(val) {
        this.valid.wholesalePrice = val >= 0.1 || !val;
        this.success.wholesalePrice = val >= 0.1;
      },
    },

    ['product.reward_points']: {
      immediate: true,
      handler(val) {
        this.valid.rewardPoints = !(val === null || val === undefined || val === '');
        this.success.rewardPoints = this.valid.rewardPoints;
      },
    },

    ['product.reward_type_id']: {
      immediate: true,
      handler(val) {
        this.valid.rewardType = Boolean(val);
        this.success.rewardType = Boolean(val);
      },
    },

    ['product.group_product']: {
      immediate: true,
      handler() {
        this.validateSellingPrice();
      },
    },

    ['product.has_image']: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.error.image = '';
          this.valid.image = true;
          this.success.image = false;
        }
      },
    },

    resetSuccess(val) {
      if (val) {
        this.success = {
          category: false,
          image: false,
          name: false,
          description: false,
          sellingPrice: false,
          maxPrice: false,
          wholesalePrice: false,
        };

        this.setResetSuccess(false);
      }
    },

    resetValidation: {
      immediate: true,
      handler(val) {
        if (val) {
          this.error = {
            category: '',
            image: '',
            name: '',
            description: '',
            sellingPrice: '',
            maxPrice: '',
            wholesalePrice: '',
          };

          this.setResetValidation(false);
        }
      },
    },
  },
};
